<template>
  <v-card>
    <v-toolbar dense>
      <router-link
        style="text-decoration: none; color: inherit"
        :to="{ name: 'Media Manager Add' }"
        :event="checkedMedia.length === 0 ? 'click' : ''"
        :disabled="checkedMedia.length > 0"
      >
        <v-btn small class="mr-2" :disabled="checkedMedia.length > 0">
          New media
          <v-icon right>mdi-file-plus-outline</v-icon>
        </v-btn>
      </router-link>
      <v-btn
        @click="deleteMediaGroupDialog"
        v-if="checkedMedia.length > 0"
        small
        class="mr-2"
      >
        Delete media
        <v-icon right>mdi-delete-forever</v-icon>
      </v-btn>

      <v-btn
        @click="setCheckedMedia()"
        small
        class="mr-2"
        v-if="checkedMedia.length > 0"
      >
        Link to pois
        <v-icon right>mdi-link</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <v-select
        v-model="filterLangId"
        :items="supportedLangs"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        item-value="id"
        outlined
        dense
        style="max-width: 200px"
        class="mx-2 my-0"
        hide-details="auto"
        label="Language"
      ></v-select>
      <v-text-field
        :hide-details="true"
        v-model="searchKeyword"
        outlined
        clearable
        prepend-icon="mdi-magnify"
        dense
        label="Search"
        style="max-width: 200px"
      >
      </v-text-field>
    </v-toolbar>
    <v-card style="height: calc(100vh - 275px);" class="overflow-auto pa-4">
      <div v-for="m in media" :key="m.id" class="mb-2">
        <media-card-multi
          :hideActions="checkedMedia.length > 0"
          :is-grid-view="false"
          :media="m"
          :checked="isCheckedMedia(m.id)"
          :showCheckbox="true"
          @changeChecked="changeChecked(m.id, $event)"
          @edit="onEdit(m.id)"
          @AddToGallery="openAddToGalleryDialog()"
          @deleted="onDeleted(m.id)"
        ></media-card-multi>
      </div>
      <v-card
        v-show="infiniteScrollDummyVisible"
        v-intersect="{
          handler: onIntersect,
          options: {
            threshold: [0.5]
          }
        }"
        key="dummy"
        ><div></div>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
import Enums from '../helpers/Enums'
import MediaCardMulti from '../components/MediaCards/MediaCardMulti'
import { mapState } from 'vuex'

export default {
  components: {
    MediaCardMulti
  },
  data() {
    return {
      checkedMedia: [],
      imageIds: [3, 2],
      fileTypes: ['all', 'audio', 'video', 'image', 'data', 'text', 'gallery'],
      defaultItem: {
        name: 'New Media Item',
        mediaTypeId: 0,
        textualContent: '',
        mediaData: '',
        path: '',
        url: '',
        parentGalleryId: 0,
        poiId: 0,
        langId: 1
      },
      dialog: false,
      showNewEditMediaDialog: false,
      editedIndex: -1,
      //media: [],
      showAddToGalleryDialog: false,
      children: [],
      searchParams: {
        langId: 0,
        search: null,
        mediaTypeId: 2,
        orderBy: 'updatedAt',
        orderDirection: 'desc'
      },
      searchKeyword: '',
      filterLangId: 0,
      searchTimer: null,
      infiniteScrollDummyVisible: false
    }
  },
  props: {
    isVisible: Boolean,
    context: String,
    media: Array
  },
  computed: {
    ...mapState('MediaManagerStore', ['mediaPageSize']),
    getActiveLang() {
      if (this.searchParams.langId === 0) {
        return this.$store.state.ProjectStore.projectConfig[
          this.$store.state.ProjectStore.projectConfig.length - 1
        ].mediaData.defaultLangId
      }
      return this.searchParams.langId
    },
    // showGhost() {
    //   return ids => {
    //     let media = this.media.filter(m => {
    //       return ids.includes(m.mediaTypeId)
    //     })
    //     if (media.length === 0) {
    //       return true
    //     }
    //     return false
    //   }
    // },
    isCheckedMedia() {
      return id => {
        return this.checkedMedia.includes(id)
      }
    },
    supportedLangs() {
      let arr = [
        {
          id: 0,
          name: 'All'
        }
      ]
      Object.entries(Enums.lang).forEach(([key, value]) => {
        if (this.projectLangs.includes(value.id)) {
          arr.push(value)
        }
      })
      return arr
    },
    projectLangs() {
      if (this.$store.state.ProjectStore.projectConfig) {
        return this.$store.state.ProjectStore.projectConfig[
          this.$store.state.ProjectStore.projectConfig.length - 1
        ].mediaData.selectedLangs
      }
      return null
    }
  },
  watch: {
    searchParams: {
      deep: true,
      async handler() {
        await this.$store.dispatch(
          'MediaManagerStore/fetchMedia',
          this.searchParams
        )
      }
    },
    searchKeyword: function(val) {
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(async () => {
        this.infiniteScrollDummyVisible = false
        await this.$store.dispatch('MediaManagerStore/resetMedia')
        await this.$store.dispatch('MediaManagerStore/resetPaging')
        this.searchParams = Object.assign({}, this.searchParams, {
          search: val
        })
      }, 500) // 1 sec delay
    },
    filterLangId: async function(val) {
      this.infiniteScrollDummyVisible = false
      await this.$store.dispatch('MediaManagerStore/resetMedia')
      await this.$store.dispatch('MediaManagerStore/resetPaging')
      this.searchParams = Object.assign({}, this.searchParams, {
        langId: val
      })
    },
    isVisible: async function(newValue) {
      if (newValue) {
        await this.$store.dispatch('MediaManagerStore/resetMedia')
        await this.$store.dispatch('MediaManagerStore/resetPaging')
        if (!this.infiniteScrollDummyVisible) await this.getData()
      }
    }
  },
  beforeMount: async function() {
    await this.$store.dispatch('MediaManagerStore/resetMedia')
    await this.$store.dispatch('MediaManagerStore/resetPaging')
  },
  beforeDestroy: async function() {
    await this.$store.dispatch('MediaManagerStore/resetMedia')
    await this.$store.dispatch('MediaManagerStore/resetPaging')
  },
  mounted: async function() {},
  created: async function() {
    // await this.$store.dispatch('MediaManagerStore/resetMedia')
    // await this.$store.dispatch('MediaManagerStore/resetPaging')
    await this.getData()
    this.mediaTypesEnum = Enums.MediaType
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.media.length >= this.mediaPageSize) {
        this.infiniteScrollDummyVisible = true // needed to prevent false positive when first rendering the list before fetch data
      }
    })
  },
  methods: {
    async getData() {
      await this.$store.dispatch(
        'MediaManagerStore/fetchMedia',
        this.searchParams
      )
      // if (this.$store.state.MediaStore.mediaContext === 'poi') {
      //   let poi = await this.$store.state.PoiStore.selectedPoi
      //
      //   await this.$store.dispatch('PoiStore/fetchPoiTypes')
      //
      //   let poiType = await this.$store.state.PoiStore.poiTypes.find(
      //     el => el.typeId === poi.poiTypeId
      //   )
      //   let parent = await this.$store.dispatch(
      //     'PoiStore/getPoisParent',
      //     poi.id
      //   )
      //   await this.$store.dispatch(
      //     'MediaStore/fetchMediaTypes',
      //     poiType.parentType
      //   )
      //   await this.$store.dispatch('MediaStore/fetchMedia')
      // }
    },
    deleteMediaGroupDialog() {
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete group of media items',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Delete',
        ok: () => {
          this.deleteMediaGroup()
        },
        cancelText: 'Cancel'
      })
    },
    async deleteMediaGroup() {
      await this.$store.dispatch(
        'MediaManagerStore/deleteMedia',
        this.checkedMedia
      )
      this.checkedMedia = []
    },
    changeChecked(id, e) {
      if (this.checkedMedia.includes(id) && !e) {
        for (let i = 0; i < this.checkedMedia.length; i++) {
          if (this.checkedMedia[i] === id) {
            this.checkedMedia.splice(i, 1)
          }
        }
      } else if (!this.checkedMedia.includes(id) && e) {
        this.checkedMedia.push(id)
      }
    },
    openMediaItemDialog(type) {
      this.$router.push({
        name: 'Media Manager Add',
        params: {
          projectId: parseInt(this.$route.params.projectId),
          type: type
        }
      })
    },
    async onMediaItemDialogClosed() {
      this.dialog = false
      this.editedIndex = -1
      this.infiniteScrollDummyVisible = false
      await this.$store.dispatch('MediaManagerStore/resetMedia')
      await this.$store.dispatch('MediaManagerStore/resetPaging')
      await this.$store.dispatch(
        'MediaManagerStore/fetchMedia',
        this.searchParams
      )
    },
    async onEdit(id, path = 'Edit') {
      await this.$store
        .dispatch('MediaManagerStore/setSelectedMediaItem', [id])
        .then(() => {
          this.$router.push({
            name: `Media Manager ${path}`,
            params: {
              projectId: parseInt(this.$route.params.projectId),
              mediaId: id
            }
          })
        })
    },
    async onDeleted(id) {
      try {
        await this.$confirm({
          title: 'Confirm delete',
          text: 'Are you sure?',
          acceptText: 'DELETE',
          cancelText: 'CANCEL'
        })
        await this.$store.dispatch('MediaManagerStore/deleteMedia', [id])
      } catch (e) {
        console.log('NO')
      }
      // .then(() => {
      //   // this.getData()
      //   this.$store.dispatch(
      //     'MediaManagerStore/fetchMedia',
      //     this.searchParams
      //   )
      // })
    },
    // openAddToGalleryDialog: async function() {
    //   if (!this.showAddToGalleryDialog) {
    //     await this.$store.dispatch(
    //       'MediaStore/getSelectedMediaItemParentGalleries'
    //     )
    //     this.showAddToGalleryDialog = true
    //   }
    // },
    onIntersect: function(entries, observer, isIntersecting) {
      this.infiniteScrollDummyVisible = false
      if (isIntersecting) {
        this.getData()
      }
    },
    setCheckedMedia() {
      this.$store.dispatch(
        'MediaManagerStore/setCheckedMedia',
        this.checkedMedia
      )
      this.onEdit(this.checkedMedia[0], 'Edit Links')
    }
  }
}
</script>

<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 4em;
  z-index: 2;
}
</style>
